import type React from 'react';

export interface HintProps {
  /**
   * Hint content, including text, links and block content such as paragraphs.
   */
  children: React.ReactNode;
  id: string;
  className?: string;
}

export function Hint({ children, id, className = '' }: HintProps) {
  return (
    <div
      id={id}
      className={`micro text-secondary ${className}`.trim()}
      // Preserve the long-word wrapping provided by the global paragraph styles.
      style={{ overflowWrap: 'break-word' }}
    >
      {children}
    </div>
  );
}
